<template>
  <div>
    <v-overlay :value="isLoadingSpinner" :opacity="`0.5`" zIndex="99999"
      ><v-progress-circular
        indeterminate
        size="70"
        width="7"
        color="primary"
      ></v-progress-circular
    ></v-overlay>
    <v-card elevation="2" outlined shaped tile class="mb-2">
      <v-card-title>{{ $t("pos") + " " + $t("brands.brand") }}</v-card-title>
      <v-snackbar
        v-model="snackbar"
        :color="snackbar_class"
        elevation="24"
        :timeout="-1"
      >
        {{ text_snackbar }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false">
            OK
          </v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">{{ $t("confirmdelete") }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">{{
              $t("cancel")
            }}</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-if="selected" scrollable v-model="showEdit" max-width="700px">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.routeId"
                      v-bind:label="$t('route')"
                      v-bind:placeholder="$t('start_typing_to_search')"
                      item-text="name"
                      item-value="id"
                      :search-input.sync="search_route"
                      :loading="isSearchingRoute"
                      :items="filtered_routes"
                      hide-no-data
                      hide-selected
                      filled
                      required
                      :rules="requiredRules"
                      readonly
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.posId"
                      v-bind:label="$t('pos')"
                      v-bind:placeholder="$t('start_typing_to_search')"
                      item-text="name"
                      item-value="id"
                      :search-input.sync="search_pos"
                      :loading="isSearchingPos"
                      :items="filtered_poses"
                      hide-no-data
                      hide-selected
                      filled
                      required
                      :rules="requiredRules"
                      readonly
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.brandId"
                      v-bind:label="$t('brands.brand')"
                      v-bind:placeholder="$t('start_typing_to_search')"
                      item-text="name"
                      item-value="id"
                      :items="brandList"
                      filled
                      hide-details="auto"
                      required
                      :rules="requiredRules"
                      @change="onChangeBrand(selected.brandId)"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.visitType"
                      v-bind:label="$t('visit_type')"
                      :items="visitTypes"
                      filled
                      required
                      item-text="label"
                      item-value="value"
                      :rules="requiredRules"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.surveyId"
                      v-bind:label="$t('Form')"
                      v-bind:placeholder="$t('start_typing_to_search')"
                      item-text="name"
                      item-value="id"
                      :items="selectedSurveyList"
                      filled
                      hide-details="auto"
                      clearable
                      required
                      :rules="requiredRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.status"
                      v-bind:label="$t('salesforce.status')"
                      :items="statusValues"
                      filled
                      required
                      :rules="requiredRules"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      v-model="selected.periods"
                      v-bind:label="$t('periods')"
                      :items="periodList"
                      multiple
                      filled
                    >
                      <template v-slot:prepend-item>
                        <v-list-item
                          ripple
                          @click="toggleSelectAllOptions('periods')"
                        >
                          <v-list-item-action>
                            <v-icon
                              :color="
                                selected.periods.length > 0
                                  ? 'indigo darken-4'
                                  : ''
                              "
                              >{{ icon }}</v-icon
                            >
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      v-model="selected.s1"
                      v-bind:label="$t('week') + ' 1'"
                      :items="weekdays"
                      item-text="label"
                      item-value="value"
                      multiple
                      filled
                    >
                      <template v-slot:prepend-item>
                        <v-list-item
                          ripple
                          @click="toggleSelectAllOptions('s1')"
                        >
                          <v-list-item-action>
                            <v-icon
                              :color="
                                selected.s1.length > 0 ? 'indigo darken-4' : ''
                              "
                              >{{ icon_selectall_week1 }}</v-icon
                            >
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      v-model="selected.s2"
                      v-bind:label="$t('week') + ' 2'"
                      :items="weekdays"
                      item-text="label"
                      item-value="value"
                      multiple
                      filled
                    >
                      <template v-slot:prepend-item>
                        <v-list-item
                          ripple
                          @click="toggleSelectAllOptions('s2')"
                        >
                          <v-list-item-action>
                            <v-icon
                              :color="
                                selected.s2.length > 0 ? 'indigo darken-4' : ''
                              "
                              >{{ icon_selectall_week2 }}</v-icon
                            >
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      v-model="selected.s3"
                      v-bind:label="$t('week') + ' 3'"
                      :items="weekdays"
                      item-text="label"
                      item-value="value"
                      multiple
                      filled
                    >
                      <template v-slot:prepend-item>
                        <v-list-item
                          ripple
                          @click="toggleSelectAllOptions('s3')"
                        >
                          <v-list-item-action>
                            <v-icon
                              :color="
                                selected.s3.length > 0 ? 'indigo darken-4' : ''
                              "
                              >{{ icon_selectall_week3 }}</v-icon
                            >
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      v-model="selected.s4"
                      v-bind:label="$t('week') + ' 4'"
                      :items="weekdays"
                      item-text="label"
                      item-value="value"
                      multiple
                      filled
                    >
                      <template v-slot:prepend-item>
                        <v-list-item
                          ripple
                          @click="toggleSelectAllOptions('s4')"
                        >
                          <v-list-item-action>
                            <v-icon
                              :color="
                                selected.s4.length > 0 ? 'indigo darken-4' : ''
                              "
                              >{{ icon_selectall_week4 }}</v-icon
                            >
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeEditDialog">
                {{ $t("cancel") }}
              </v-btn>
              <v-btn
                color="blue darken-1"
                :loading="isSaving"
                text
                @click="onSaveClick(selected)"
              >
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-card-text>
        <b-alert show variant="info"
          ><b>Importante</b>: Condicion necesaria para añadir una marca: Tiene
          que existir una ruta con los valores routeId, posId
        </b-alert>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-btn
              v-if="importExcelTemplatePathName"
              color="blue darken-1"
              @click="downloadExcelTemplate(importExcelTemplatePathName)"
            >
              <b-icon icon="download" aria-hidden="true"></b-icon> Plantilla
              Import
            </v-btn>
            <v-btn
              color="success"
              dark
              class="ml-2"
              :loading="isSelecting"
              @click="onUploadExcelClick"
            >
              <b-icon icon="file-excel-fill" aria-hidden="true"></b-icon>
              {{ buttonText }}
            </v-btn>
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept=".xls,.xlsx"
              @change="onFileChanged"
            />
            <v-btn color="warning" dark class="ml-2" @click="downloadExcel">
              <b-icon icon="file-excel-fill" aria-hidden="true"></b-icon>
              Export Excel
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="importFailedRows && importFailedRows.length">
          <v-col>
            <b-alert show variant="danger"
              ><b>Errores en la importación</b>: revisa los siguientes
              errores</b-alert
            >
            <b-table
              style="width: 100%"
              sticky-header="500px"
              dark
              bordered
              small
              striped
              :items="importFailedRows"
            >
            </b-table>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <ve-table
              ref="tableRefroutes"
              id="pos_routes_table"
              fixed-header
              max-height="calc(100vh - 330px)"
              :columns="columns"
              :table-data="data"
              :border-around="true"
              :border-x="true"
              :border-y="true"
              :scroll-width="1500"
              :sort-option="sortOption"
              :cell-style-option="cellStyleOption"
            />
            <div v-show="showEmpty" class="empty-data">Data Empty.</div>
            <div class="table-pagination mt-2 text-right">
              <ve-pagination
                :total="totaldata"
                :page-index="pageIndex"
                :page-size="pageSize"
                :page-size-option="pageOptions"
                @on-page-number-change="pageNumberChange"
                @on-page-size-change="pageSizeChange"
              />
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";
import download from "js-file-download";
import _ from "lodash";
import FilterableAjaxFieldCheckboxesSimple from "../../../components/filterableCheckbox/filterableAjaxFieldCheckboxesSimple.vue";

export default {
  name: "posformroutes",
  data: function() {
    return {
      importFailedRows: null,
      importExcelTemplatePathName: null,
      filterlist_fetch_url: "pos/posformroutes/getfilterlist",
      filterable_col_list: [
        "routeId",
        "route",
        "brand",
        "visitType",
        "surveyId",
        "survey",
        "posId",
        "pos",
        "address",
        "periods",
        "week1",
        "week2",
        "week3",
        "week4",
        "status"
      ],
      filter: {},
      lastAppliedFilters: {},
      filterCriteria: {
        routeId: {},
        route: [],
        brand: [],
        visitType: [],
        surveyId: {},
        survey: [],
        posId: {},
        pos: [],
        periods: [],
        week1: [],
        week2: [],
        week3: [],
        week4: [],
        status: []
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (this.filterable_col_list.includes(column.field)) {
            return "filterable-column " + column.field;
          }
        }
      },
      loadingInstance: null,
      sorting: null,
      sortBy: null, // Track sorted column
      sortOrder: null, // Track sort order
      sortOption: {
        sortChange: params => {
          this.sortChange(params);
        }
      },
      pageIndex: 0,
      pageSize: 100,
      pageOptions: [10, 50, 100],
      showEmpty: false,

      totaldata: 0,
      data: [],
      weekdays: [],
      statusValues: [],
      visitTypes: [],
      periodsCount: 13,
      periodList: [],
      brandList: [],
      surveyList: [],
      selectedSurveyList: [],

      /********** others **********/
      isSelecting: false,
      selectedFile: null,
      defaultButtonText: "Import Excel",
      /********** snackbar **********/
      snackbar: false,
      text_snackbar: "The imported file is invalid.",
      vertical: true,
      snackbar_class: "deep-purple",

      valid: true,
      requiredRules: [v => !!v || "Required"],
      requiredRulesArray: [v => (!!v && v.length > 0) || "Required"],
      selected: null,
      editedIndex: -1,
      showEdit: false,

      search_route: null,
      isSearchingRoute: false,
      filtered_routes: [],
      search_brand: null,
      isSearchingBrand: false,
      filtered_brands: [],
      search_survey: null,
      isSearchingSurvey: false,
      filtered_surveys: [],
      search_pos: null,
      isSearchingPos: false,
      filtered_poses: [],

      dialogDelete: false,
      deleteItem: -1,

      isSaving: false,

      /**************************** Loading Spinner Overlay ****************************/
      isLoadingSpinner: false
    };
  },
  watch: {
    async search_route(val) {
      this.searchValues("route", val);
    },
    async search_brand(val) {
      this.searchValues("brand", val);
    },
    async search_survey(val) {
      this.searchValues("survey", val);
    },
    async search_pos(val) {
      this.searchValues("pos", val);
    }
  },
  computed: {
    likesAllPeriods() {
      return this.selected.periods.length === this.periodList.length;
    },
    icon() {
      if (this.likesAllPeriods) return "mdi-close-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllWeek1() {
      return this.selected.s1.length === this.weekdays.length;
    },
    icon_selectall_week1() {
      if (this.likesAllWeek1) return "mdi-close-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllWeek2() {
      return this.selected.s2.length === this.weekdays.length;
    },
    icon_selectall_week2() {
      if (this.likesAllWeek2) return "mdi-close-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllWeek3() {
      return this.selected.s3.length === this.weekdays.length;
    },
    icon_selectall_week3() {
      if (this.likesAllWeek3) return "mdi-close-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllWeek4() {
      return this.selected.s4.length === this.weekdays.length;
    },
    icon_selectall_week4() {
      if (this.likesAllWeek4) return "mdi-close-box";
      return "mdi-checkbox-blank-outline";
    },
    formTitle() {
      return this.editedIndex === -1 || this.editedIndex === undefined
        ? this.$t("newitem")
        : this.$t("edititem");
    },
    col_routeId() {
      return {
        key: "routeId",
        title: "ID " + this.$t("route"),
        field: "routeId",
        align: "left",
        width: 100,
        sortBy: "routeId",
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <input
                  type="number"
                  class="filter_date_picker"
                  v-model={this.filterCriteria["routeId"]["from"]}
                  value={this.filterCriteria["routeId"]["from"]}
                  placeholder="From - "
                />
                <br />
                <input
                  type="number"
                  class="filter_date_picker"
                  v-model={this.filterCriteria["routeId"]["to"]}
                  value={this.filterCriteria["routeId"]["to"]}
                  placeholder="To - "
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "routeId")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_route() {
      return {
        key: "route",
        title: this.$t("route") + " " + this.$t("brands.name"),
        field: "route",
        align: "left",
        width: 200,
        sortBy: "route",
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.route && row.route.name}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                {/* [Modified by E2logy]: replaced old filters with newly created filter component called `FilterableAjaxFieldCheckboxesSimple` */}
                <FilterableAjaxFieldCheckboxesSimple
                  v-model={this.filterCriteria["route"]}
                  apiUrl={this.filterlist_fetch_url}
                  columnName="route"
                  isFullText={true}
                  valueField="name"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "route")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_brand() {
      return {
        key: "brand",
        title: this.$t("brands.brand") + " " + this.$t("brands.name"),
        field: "brand",
        align: "left",
        width: 200,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.brand && row.brand.name}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                {/* [Modified by E2logy]: replaced old filters with newly created filter component called `FilterableAjaxFieldCheckboxesSimple` */}
                <FilterableAjaxFieldCheckboxesSimple
                  v-model={this.filterCriteria["brand"]}
                  apiUrl={this.filterlist_fetch_url}
                  columnName="brand"
                  isFullText={true}
                  valueField="name"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "brand")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_visittype() {
      return {
        key: "visitType",
        title: this.$t("visit_type"),
        field: "visitType",
        align: "left",
        sortBy: "",
        width: 150,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.visittype_label}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableCheckboxesOthers
                  v-model={this.filterCriteria["visitType"]}
                  dataList={this.visitTypes}
                  filterCriteria={this.filterCriteria["visitType"]}
                  itemvalue="value"
                  itemlabel="label"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "visitType")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_surveyId() {
      return {
        key: "surveyId",
        title: "ID " + this.$t("Form"),
        field: "surveyId",
        align: "left",
        width: 150,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return (
            <span>
              {row.surveys && row.surveys?.[0] && row.surveys?.[0]?.surveyId}
            </span>
          );
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <input
                  type="number"
                  class="filter_date_picker"
                  v-model={this.filterCriteria["surveyId"]["from"]}
                  value={this.filterCriteria["surveyId"]["from"]}
                  placeholder="From - "
                />
                <br />
                <input
                  type="number"
                  class="filter_date_picker"
                  v-model={this.filterCriteria["surveyId"]["to"]}
                  value={this.filterCriteria["surveyId"]["to"]}
                  placeholder="To - "
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "surveyId")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_survey() {
      return {
        key: "survey",
        title: this.$t("Form") + " " + this.$t("brands.name"),
        field: "survey",
        align: "left",
        width: 200,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return (
            <span>{row.surveys && row.surveys[0] && row.surveys[0]?.name}</span>
          );
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                {/* [Modified by E2logy]: replaced old filters with newly created filter component called `FilterableAjaxFieldCheckboxesSimple` */}
                <FilterableAjaxFieldCheckboxesSimple
                  v-model={this.filterCriteria["survey"]}
                  apiUrl={this.filterlist_fetch_url}
                  columnName="survey"
                  isFullText={true}
                  valueField="name"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "survey")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_posId() {
      return {
        key: "posId",
        title: "ID " + this.$t("pos"),
        field: "posId",
        align: "left",
        width: 100,
        sortBy: "",
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <input
                  type="number"
                  class="filter_date_picker"
                  v-model={this.filterCriteria["posId"]["from"]}
                  value={this.filterCriteria["posId"]["from"]}
                  placeholder="From - "
                />
                <br />
                <input
                  type="number"
                  class="filter_date_picker"
                  v-model={this.filterCriteria["posId"]["to"]}
                  value={this.filterCriteria["posId"]["to"]}
                  placeholder="To - "
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "posId")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_pos() {
      return {
        key: "pos",
        title: this.$t("pos") + " " + this.$t("brands.name"),
        field: "pos",
        align: "left",
        width: 200,
        sortBy: "",
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.po && row.po.name}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                {/* [Modified by E2logy]: replaced old filters with newly created filter component called `FilterableAjaxFieldCheckboxesSimple` */}
                <FilterableAjaxFieldCheckboxesSimple
                  v-model={this.filterCriteria["pos"]}
                  apiUrl={this.filterlist_fetch_url}
                  columnName="pos"
                  isFullText={true}
                  valueField="name"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "pos")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_address() {
      return {
        key: "address",
        title: this.$t("address"),
        field: "address",
        align: "left",
        width: 200,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.address_label}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <v-text-field
                  value={this.filterCriteria["address"]}
                  on-input={value => (this.filterCriteria["address"] = value)}
                  placeholder="Search Address Name"
                ></v-text-field>
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "address")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_periods() {
      return {
        key: "periods",
        title: this.$t("periods"),
        field: "periods",
        align: "left",
        width: 200,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.periods_label}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            let periods = [];
            for (let i = 1; i <= this.periodsCount; i++) {
              periods.push(i.toString());
            }
            return (
              <div class="custom-filter">
                <filterableCheckboxes
                  v-model={this.filterCriteria["periods"]}
                  dataList={periods}
                  filterCriteria={this.filterCriteria["periods"]}
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "periods")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_week1() {
      return {
        key: "week1",
        title: this.$t("week") + " 1",
        field: "week1",
        align: "left",
        width: 200,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.weeklabel_1}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableCheckboxesOthers
                  v-model={this.filterCriteria["week1"]}
                  dataList={this.weekdays}
                  filterCriteria={this.filterCriteria["week1"]}
                  itemvalue="value"
                  itemlabel="label"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "week1")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_week2() {
      return {
        key: "week2",
        title: this.$t("week") + " 2",
        field: "week2",
        align: "left",
        width: 200,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.weeklabel_2}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableCheckboxesOthers
                  v-model={this.filterCriteria["week2"]}
                  dataList={this.weekdays}
                  filterCriteria={this.filterCriteria["week2"]}
                  itemvalue="value"
                  itemlabel="label"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "week2")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_week3() {
      return {
        key: "week3",
        title: this.$t("week") + " 3",
        field: "week3",
        align: "left",
        width: 200,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.weeklabel_3}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableCheckboxesOthers
                  v-model={this.filterCriteria["week3"]}
                  dataList={this.weekdays}
                  filterCriteria={this.filterCriteria["week3"]}
                  itemvalue="value"
                  itemlabel="label"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "week3")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_week4() {
      return {
        key: "week4",
        title: this.$t("week") + " 4",
        field: "week4",
        align: "left",
        width: 200,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.weeklabel_4}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableCheckboxesOthers
                  v-model={this.filterCriteria["week4"]}
                  dataList={this.weekdays}
                  filterCriteria={this.filterCriteria["week4"]}
                  itemvalue="value"
                  itemlabel="label"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "week4")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_status() {
      return {
        key: "status",
        title: this.$t("status"),
        field: "status",
        align: "left",
        sortBy: "",
        width: 150,
        fixed: "right",
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <v-checkbox
                  v-model={this.filterCriteria["status"]}
                  label="active"
                  value="active"
                ></v-checkbox>
                <v-checkbox
                  v-model={this.filterCriteria["status"]}
                  label="inactive"
                  value="inactive"
                ></v-checkbox>
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "status")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_actions() {
      return {
        key: "actions",
        title: this.$t("edititem"),
        field: "actions",
        align: "center",
        width: 100,
        fixed: "right",
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return (
            <div>
              <v-icon
                medium
                color="primary"
                class="mr-2"
                on-click={() => this.onItemEdit(row)}
              >
                mdi-pencil
              </v-icon>
              {row.brandId && (
                <v-icon
                  medium
                  color="red"
                  class="mr-2"
                  on-click={() => this.onItemRemove(row)}
                >
                  mdi-delete
                </v-icon>
              )}
            </div>
          );
        }
      };
    },
    columns() {
      return [
        this.col_routeId,
        this.col_route,
        this.col_posId,
        this.col_pos,
        this.col_address,
        this.col_visittype,
        this.col_brand,
        this.col_surveyId,
        this.col_survey,
        this.col_periods,
        this.col_week1,
        this.col_week2,
        this.col_week3,
        this.col_week4,
        this.col_status,
        this.col_actions
      ];
    },
    buttonText() {
      return this.isSelecting ? "Uploading..." : this.defaultButtonText;
    }
  },
  methods: {
    toggleSelectAllOptions(flag) {
      if (flag === "periods") {
        if (this.likesAllPeriods) {
          this.selected.periods = [];
        } else {
          this.selected.periods = this.periodList;
        }
      } else if (flag === "s1") {
        if (this.likesAllWeek1) {
          this.selected.s1 = [];
        } else {
          this.selected.s1 = this.weekdays.map(item => item.value);
        }
      } else if (flag === "s2") {
        if (this.likesAllWeek2) {
          this.selected.s2 = [];
        } else {
          this.selected.s2 = this.weekdays.map(item => item.value);
        }
      } else if (flag === "s3") {
        if (this.likesAllWeek3) {
          this.selected.s3 = [];
        } else {
          this.selected.s3 = this.weekdays.map(item => item.value);
        }
      } else if (flag === "s4") {
        if (this.likesAllWeek4) {
          this.selected.s4 = [];
        } else {
          this.selected.s4 = this.weekdays.map(item => item.value);
        }
      }
    },
    async searchValues(fieldname, val) {
      if (!val) val = "";
      let fetch_url = `${this.filterlist_fetch_url}?column=${fieldname}&isFullText=true&filterValue=${val}`;
      this.isSearchingRoute = true;
      const resp = await ApiService.get(fetch_url);
      if (fieldname === "route") {
        this.filtered_routes = resp.data;
      } else if (fieldname === "brand") {
        this.filtered_brands = resp.data;
      } else if (fieldname === "survey") {
        this.filtered_surveys = resp.data;
      } else if (fieldname === "pos") {
        this.filtered_poses = resp.data;
      }
      this.isSearchingRoute = false;
    },
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getDataFromApi();
    },
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.getDataFromApi();
    },
    sortChange(params) {
      console.log("Sort Change: ", params);

      if (typeof params === "object" && Object.keys(params).length > 0) {
        Object.keys(params).forEach(val => {
          if (params[val].trim().length) {
            this.sortBy = val;
            this.sortOrder = params[val] === "desc" ? "DESC" : "ASC";
          }
        });
      }

      this.getDataFromApi();
    },
    searchConfirm(closeFn) {
      closeFn();
      this.getQueryParams();
      this.getDataFromApi();
    },
    searchCancel(closeFn, cancelFilterKey) {
      closeFn();
      if (cancelFilterKey === "address") {
        this.filterCriteria[cancelFilterKey] = null;
      } else {
        this.filterCriteria[cancelFilterKey] = {};
      }
      this.getQueryParams();
      this.getDataFromApi();
    },
    show() {
      this.loadingInstance = this.$veLoading({
        target: document.querySelector("#pos_routes_table"),
        name: "flow" // gird, flow, wave, bounce,
      });
      this.loadingInstance.show();
    },
    close() {
      this.loadingInstance.close();
    },
    getQueryParams() {
      let query_params_string = "";
      let query_params = [];
      query_params.push("page=" + this.pageIndex);
      query_params.push("itemsPerPage=" + this.pageSize);
      if (this.sorting !== null) {
        for (const [key, value] of Object.entries(this.sorting)) {
          if (value !== null && value !== "") {
            query_params.push("sortby=" + key);
            query_params.push(
              "sortdesc=" + (value === "desc" ? "true" : "false")
            );
          }
        }
      }

      let filterModel = [];
      for (const [key, value] of Object.entries(this.filterCriteria)) {
        if (value !== "" && value !== null) {
          if (Object.keys(value).length > 0) {
            filterModel.push({
              columnField: key,
              filterValue: value
            });
          }
        }
      }
      let filter_columns = document.querySelectorAll(
        "#pos_routes_table .filterable-column"
      );
      for (let i = 0; i < filter_columns.length; i++) {
        filter_columns[i].classList.remove("filter_active");
      }
      if (filterModel.length > 0) {
        filterModel.map(filter_item => {
          for (let i = 0; i < filter_columns.length; i++) {
            if (filter_columns[i].classList.contains(filter_item.columnField)) {
              filter_columns[i].classList.add("filter_active");
            }
          }
          return filter_item;
        });
      }

      query_params_string += query_params.join("&");
      if (filterModel.length > 0) {
        query_params_string +=
          "&filterModel=" + encodeURIComponent(JSON.stringify(filterModel));
      }
      return query_params_string;
    },
    // async getDataFromApi() {
    //   this.show();
    //   let query_params_string = this.getQueryParams();
    //   let fetch_url = "pos/posformroutes";
    //   if (query_params_string !== "") {
    //     fetch_url += "?" + query_params_string;
    //   }
    //   try {
    //     const resp = await ApiService.get(fetch_url);
    //     this.data = resp.data;
    //     this.spv_list = resp.spv_list;

    //     if (this.data.length > 0) {
    //       this.showEmpty = false;
    //     } else {
    //       this.showEmpty = true;
    //     }
    //     this.totaldata = resp.total;
    //     this.brandList = resp.brandList;
    //     this.surveyList = resp.surveyList;
    //     this.weekdays = resp.weekdays;
    //     this.statusValues = resp.statusValues;
    //     this.periodsCount = resp.periodsCount;
    //     this.visitTypes = resp.visitTypes;
    //     this.importExcelTemplatePathName = resp.importExcelTemplatePathName;
    //     this.periodList = [];
    //     for (let i = 1; i <= this.periodsCount; i++) this.periodList.push(i);
    //     this.close();
    //   } catch (error) {
    //     this.close();
    //   }
    // },

    /**
     * [Added by E2logy]: Created a separate method to generate filters dynmaically
     * Generates the filter model based on the current filter criteria.
     * This method processes each filter criterion and constructs a filter model
     * that can be used in API requests.
     */
    async generateFilters() {
      let filterModel = {
        visitType: [],
        periods: [],
        week1: [],
        week2: [],
        week3: [],
        week4: []
      };

      try {
        for (const [key, value] of Object.entries(this.filterCriteria)) {
          if (key === "periods" && Array.isArray(value) && value.length > 0) {
            // Only include valid, numeric period values
            const periods = value
              .map(v => parseInt(v, 10))
              .filter(v => !isNaN(v) && v > 0 && v <= this.periodsCount);

            if (periods.length > 0) {
              filterModel.periods = periods;
            }
          }

          if (key === "status") {
            let statuses = [];

            if (value["active"]) {
              statuses.push("active");
            }

            if (value["inactive"]) {
              statuses.push("inactive");
            }

            if (statuses.length) {
              filterModel[key] = statuses;
            }
          }

          if (
            key === "week1" ||
            key === "week2" ||
            key === "week3" ||
            key === "week4"
          ) {
            try {
              if (value && typeof value === "object") {
                let processedItems = [];

                if (value.L) {
                  if (Array.isArray(value.L)) {
                    processedItems = processedItems.concat(value.L);
                  } else {
                    processedItems.push(value.L);
                  }
                }
                if (value.M) {
                  if (Array.isArray(value.M)) {
                    processedItems = processedItems.concat(value.M);
                  } else {
                    processedItems.push(value.M);
                  }
                }
                if (value.X) {
                  if (Array.isArray(value.X)) {
                    processedItems = processedItems.concat(value.X);
                  } else {
                    processedItems.push(value.X);
                  }
                }

                if (value.J) {
                  if (Array.isArray(value.J)) {
                    processedItems = processedItems.concat(value.J);
                  } else {
                    processedItems.push(value.J);
                  }
                }

                if (value.V) {
                  if (Array.isArray(value.V)) {
                    processedItems = processedItems.concat(value.V);
                  } else {
                    processedItems.push(value.V);
                  }
                }

                if (value.S) {
                  if (Array.isArray(value.S)) {
                    processedItems = processedItems.concat(value.S);
                  } else {
                    processedItems.push(value.S);
                  }
                }

                if (value.D) {
                  if (Array.isArray(value.D)) {
                    processedItems = processedItems.concat(value.D);
                  } else {
                    processedItems.push(value.D);
                  }
                }

                // Use dynamic property assignment for week filters
                if (key === "week1") {
                  filterModel.key1 = processedItems;
                } else if (key === "week2") {
                  filterModel.key2 = processedItems;
                } else if (key === "week3") {
                  filterModel.key3 = processedItems;
                } else if (key === "week4") {
                  filterModel.key4 = processedItems;
                }
              }
            } catch (error) {
              console.log("Error processing week filter: ", error);
              // Ensure filterModel[key] is an array even on error to prevent further issues

              filterModel[key] = [];
            }
          }

          if (value !== "" && value !== null) {
            if (key === "visitType") {
              if (value["PHONE"]) {
                filterModel.visitType.push("PHONE");
              }
              if (value["PRESENT"]) {
                filterModel.visitType.push("PRESENT");
              }
              if (value["AGENDA"]) {
                filterModel.visitType.push("AGENDA");
              }
              if (value["SCHEDULED"]) {
                filterModel.visitType.push("SCHEDULED");
              }
            } else if (
              key === "routeId" ||
              key === "surveyId" ||
              key === "posId"
            ) {
              if (value.from !== "" || value.to !== "") {
                filterModel[key] = value;
              }
            } else {
              if (Object.keys(value).length > 0) {
                filterModel[key] = value;
              }
            }
          }
        }
      } catch (error) {
        console.log("Error in generateFilters: ", error);
      }

      return filterModel;
    },

    /**
     * [Added by E2logy]:
     * Fetches data from the API and updates the component's state.
     * This method handles pagination, sorting, and filtering of the data.
     */
    async getDataFromApi() {
      this.show();
      let fetch_url = "pos/pos-brands";

      this.data = [];
      // Generate the new filters
      const newFilters = await this.generateFilters();

      if (
        JSON.stringify(newFilters) !== JSON.stringify(this.lastAppliedFilters)
      ) {
        this.pageIndex = 1; // Reset to the first page
      }

      this.filters = newFilters;
      this.lastAppliedFilters = JSON.parse(JSON.stringify(newFilters));

      try {
        const resp = await ApiService.post(fetch_url, {
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
          filters: this.filters,
          sortBy: this.sortBy ?? "routeId",
          sortOrder: this.sortOrder ?? "DESC"
        });

        if (resp.success) {
          this.data = resp.data;
          this.brandList = resp.brandList;
          this.surveyList = resp.surveyList;
          this.weekdays = resp.weekdays;
          this.statusValues = resp.statusValues;
          this.periodsCount = resp.periodsCount;
          this.visitTypes = resp.visitTypes;
          this.totaldata = resp.pagination.totalRows;
          this.periodList = [];
          for (let i = 1; i <= this.periodsCount; i++) this.periodList.push(i);
        }
      } catch (error) {
        console.log("Error fetching brand list: ", error);
      } finally {
        this.close();
      }
    },

    closeEditDialog() {
      this.showEdit = false;
      this.$nextTick(() => {
        this.selected = null;
        this.editedIndex = -1;
      });
    },
    async createSelectedModel(item) {
      let model = {};
      model = {
        routePosId: null,
        routePosSurveyId: null,
        routeId: _.get(item, "routeId"),
        route: _.get(item, "route"),
        posId: _.get(item, "posId"),
        pos: _.get(item, "po"),
        brandId: _.get(item, "brandId"),
        brand: _.get(item, "brand"),
        surveyId: _.get(item, "surveys"),
        survey: _.get(item, "surveys"),
        visitType: _.get(item, "visitType"),
        periods: _.get(item, "periods"),
        status: _.get(item, "status"),
        weekdetails: _.get(item, "weekdetails"),
        s1: _.get(item, "s1"),
        s2: _.get(item, "s2"),
        s3: _.get(item, "s3"),
        s4: _.get(item, "s4")
      };

      console.log("Model Periods: ", model.periods);

      if (!model.survey) {
        model.routePosId = _.get(item, "id");
      } else if (
        model.survey &&
        model.survey[0] &&
        model.survey?.[0]?.route_pos_surveys
      ) {
        // model.routePosId = model.survey?.route_pos_surveys.routePosId;
        // model.routePosSurveyId = model.survey?.route_pos_surveys.id;

        model.routePosId =
          model?.survey?.[0]?.route_pos_surveys?.routePosId ?? null;
        model.routePosSurveyId =
          model?.survey[0]?.route_pos_surveys?.id || null;
        model.surveyId = model?.survey?.[0]?.surveyId;
        model.survey = model?.survey?.[0];
      }
      if (model?.route) {
        await this.searchValues("route", model.route?.name);
      } else {
        await this.searchValues("route", "");
      }
      if (model?.pos) {
        await this.searchValues("pos", model.pos?.name);
      } else {
        await this.searchValues("pos", "");
      }
      await this.searchValues("survey", "");
      for (let i = 1; i <= 4; i++) {
        if (model[`s${i}`]) {
          model[`s${i}`] = model[`s${i}`].split(",");
        } else {
          model[`s${i}`] = [];
        }
      }
      if (model.status === undefined) {
        model.status = "active";
      }
      if (model.visitType === undefined) {
        model.visitType = "PRESENT";
      }

      if (model.brandId) {
        this.selectedSurveyList = this.filtered_surveys.filter(
          el => el.brandId === model.brandId
        );
      } else {
        this.selectedSurveyList = [];
      }
      return model;
    },
    async onItemEdit(item) {
      console.log("Row: ", item);
      this.selected = await this.createSelectedModel(item);
      this.editedIndex = this.selected.id;
      this.showEdit = true;
    },
    onChangeBrand(selectedBrandId) {
      if (selectedBrandId) {
        this.selectedSurveyList = this.filtered_surveys.filter(
          el => el.brandId === selectedBrandId
        );
      } else {
        this.selectedSurveyList = [];
      }
    },
    async onSaveClick(item) {
      if (this.$refs.form.validate()) {
        this.isSaving = true;
        let body = item;
        await ApiService.post(`pos/posformroutes/`, body);
        logInfo("éxito");
        this.showEdit = false;
        this.isSaving = false;
        this.getDataFromApi();
      }
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.deleteItem = null;
      });
    },
    onItemRemove(item) {
      this.deleteItem = item;
      console.log(this.deleteItem);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      if (this.deleteItem) {
        this.closeDelete();
        const { id, surveyId } = this.deleteItem;
        let deleteCriteria = `${id}/${surveyId}`;
        ApiService.delete(`pos/posformroutes/${deleteCriteria}`).then(() => {
          logInfo("eliminada");
          this.getDataFromApi();
        });
      }
    },
    async downloadExcel() {
      this.show();
      // let query_params_string = this.getQueryParams();
      // console.log(query_params_string);
      // let fetch_url = "pos/posformroutes/downloadexcel";
      // if (query_params_string !== "") {
      //   fetch_url += "?" + query_params_string;
      // }
      let fetch_url = "pos/pos-brands";

      try {
        // const response = await ApiService.get(fetch_url, {
        //   responseType: "blob"
        // });

        const newFilters = await this.generateFilters();

        this.filters = newFilters;
        const response = await ApiService.post(
          fetch_url,
          {
            pageIndex: -1,
            filters: newFilters
          },
          {
            responseType: "blob"
          }
        );
        download(response, "posformroutes.xlsx");
        this.close();
      } catch (error) {
        this.close();
      }
    },
    onUploadExcelClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: false }
      );
      this.$refs.uploader.click();
    },
    async onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      console.log(this.selectedFile);
      if (
        window.confirm(
          `¿Está seguro de que desea cargar este archivo de Excel?`
        )
      ) {
        this.isSelecting = true;
        this.isLoadingSpinner = true;
        let data = new FormData();
        data.append("file", this.selectedFile);
        this.$refs.uploader.value = "";
        try {
          const response = await ApiService.post(
            `pos/posformroutes/uploadexcel`,
            data,
            {
              headers: {
                "Content-Type": `multipart/form-data;`
              }
            }
          );
          const {
            success,
            insertedRowCount,
            failedRows,
            invalidFile,
            message,
            errorLog
          } = response;

          this.importFailedRows = errorLog;

          this.snackbar_class = "deep-purple";
          if (success && insertedRowCount > 0) {
            this.text_snackbar = `${insertedRowCount} row${
              insertedRowCount > 1 ? "s" : ""
            } imported !`;
            this.snackbar = true;
            this.getDataFromApi();
          } else if (failedRows) {
            this.text_snackbar = `Inserted count: ${response.insertedRowCount}, Failed count: ${response.failedRows.length}`;
            this.snackbar = true;
            this.exportCSVfileGlobal(response.titles, response.failedRows);
            this.getDataFromApi();
          } else if (!invalidFile && message) {
            this.text_snackbar = message;
            this.snackbar_class = "red";
            this.snackbar = true;
          }
          this.isSelecting = false;
          this.isLoadingSpinner = false;
        } catch (error) {
          console.log(error);
          this.isSelecting = false;
        }
      }
    },
    async downloadExcelTemplate(downloadFile) {
      let downloadfile = ApiService.getExcelTemplateFileUri(downloadFile);
      try {
        const response = await ApiService.get(downloadfile, {
          responseType: "arraybuffer"
        });
        download(response, downloadFile);
      } catch (error) {
        // this.close();
      }
    },
    init() {
      this.getDataFromApi();
    },
    /**
     * Build a filter object for the optimized API.
     * @param {String} column - The column name (e.g., "brand", "status", etc.)
     * @param {*} selectedValue - The value selected from the dropdown (can be string, number, array, etc.)
     * @returns {Object} Filter object for request body
     */
    buildFilterObject(column, selectedValue) {
      // If the value is an array and empty, don't include it
      if (Array.isArray(selectedValue) && selectedValue.length === 0) {
        return {};
      }
      // If the value is null/undefined/empty string, don't include it
      if (
        selectedValue === null ||
        selectedValue === undefined ||
        selectedValue === ""
      ) {
        return {};
      }
      // Return filter object in the expected format
      return {
        filters: [
          {
            column: column,
            value: selectedValue
          }
        ]
      };
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style>
table.sub_data_table {
  width: 100%;
}
table.sub_data_table tbody tr td {
  border: none !important;
}
.ve-table
  .ve-table-container
  .ve-table-border-y
  table.sub_data_table
  tbody
  tr
  td:first-child {
  border: none !important;
  border-bottom: 1px solid #9f9f9f !important;
}
.ve-table.ve-table-border-around
  .ve-table-container
  table.ve-table-content.ve-table-border-x
  table.sub_data_table
  tr:last-child
  > td {
  border: none !important;
}
</style>
